import {
  isBannerAdObject,
  IXandrAdObject,
  IXandrBannerAdObject,
} from "@almamedia/amr-adtech-stack/lib/services/ads/adrequest";
import { IPlacement } from "@almamedia/amr-adtech-stack/lib/services/ads/adsservice";
import { createLogger } from "@almamedia/amr-adtech-stack/lib/utils";
import { StackContext } from "../../context";
import { ICustomVariables } from "../../data-layer/data-layer";
import { SiteNativeTemplate } from "../../native/native";
import {
  paradeStyles,
  removeWallpaperStyles,
  wallpaperStyles,
} from "./custom-styles";
import { outstream } from "./outstream";

const logger = createLogger("il-custom-needs");

function changeParadeId(reverse?: boolean): void {
  try {
    if (reverse) {
      // Reverse parade-1 element id
      if (document.getElementById("almad-parade-removed")) {
        removeWallpaperStyles();
        const paradeE = document.getElementById("almad-parade-1");
        if (paradeE) {
          paradeE.id = "almad-parade-wallpaper";
        }
        const removedParadeE = document.getElementById("almad-parade-removed");
        if (removedParadeE) {
          removedParadeE.id = "almad-parade-1";
        }

        window.ALMA.ad?.clear(["#almad-parade-wallpaper"]);

        const wallpaperE = document.getElementById("almad-parade-wallpaper");
        if (wallpaperE) {
          wallpaperE.style.height = "auto";
        }
      }
    } else {
      // Change parade-1 elment id to be able to display parade-1 at the top of the page
      const removedParadeE = document.getElementById("almad-parade-removed");
      if (!removedParadeE) {
        const paradeE = document.getElementById("almad-parade-1");
        if (paradeE) {
          paradeE.id = "almad-parade-removed";
        }

        const wallpaperE = document.getElementById("almad-parade-wallpaper");
        if (wallpaperE) {
          wallpaperE.id = "almad-parade-1";
          // Something is adding inline display: none to this element - could be related to ast.js v. 0.30.0?
          wallpaperE.style.display = "block";
        }

        window.ALMA.ad?.clear(["#almad-parade-removed"]);
        if (paradeE) {
          paradeE.style.display = "none";
        }
      }
    }
  } catch (e) {
    logger.logError("changeParadeId", e);
  }
}

function refreshAndSetKW(
  placements: string[],
  modifications: Record<string, unknown>
) {
  for (let x = 0; x < placements.length; x += 1) {
    window.apntag.modifyTag(placements[x], modifications);
  }
  window.apntag.refresh(placements);
}

declare global {
  interface Window {
    programmaticWallpaper?: boolean;
  }
}

function detectProgrammaticWallpaper(adObj: IXandrBannerAdObject): void {
  const targetAdObj: {
    buyerMemberId: number;
    height: number;
    width: number;
    adType: string;
    creativeId: number;
  } = { ...adObj } as any;

  if (window.location.search.indexOf("programmatic_override") !== -1) {
    targetAdObj.buyerMemberId = 1234;
  }

  // Programmatic wallpaper detection
  if (
    targetAdObj.creativeId === 159661578 ||
    (targetAdObj.buyerMemberId !== 6931 &&
      targetAdObj.height === 1150 &&
      targetAdObj.width === 1600 &&
      targetAdObj.adType === "banner")
  ) {
    logger.logInfo(
      "Programmatic wallpaper on almad-parade-1",
      JSON.stringify(targetAdObj, null, 2)
    );

    // Reload wallpaper
    const divIds = [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-skyscraper-2",
    ];
    const modify = {
      forceCreativeId: 104801021,
    };
    refreshAndSetKW(divIds, modify);

    wallpaperStyles(true);
    window.programmaticWallpaper = true;
  } else if (
    targetAdObj.buyerMemberId === 6931 &&
    targetAdObj.height === 1150 &&
    targetAdObj.width === 1600 &&
    targetAdObj.adType === "banner"
  ) {
    logger.logInfo(
      "Wallpaper on almad-parade-1 from member 6931 - collapse ad placement - check lineitem setup",
      JSON.stringify(targetAdObj, null, 2)
    );
    window.top.apntag.collapseAd("almad-parade-1");
  } else {
    paradeStyles(`${targetAdObj.height}px`); // ??? onko tässä ollut + 14
  }
}

function programmaticWallpaper(reverse?: boolean): void {
  try {
    if (reverse) {
      const removedParadeE = document.getElementById("almad-parade-removed");
      if (removedParadeE) {
        removeWallpaperStyles();

        removedParadeE.id = "almad-parade-1";
        // Removes whole style element (basically height 400px)
        const wallpaperE = document.getElementById("almad-parade-wallpaper");

        if (wallpaperE) {
          wallpaperE.removeAttribute("style");
        }
      }
    } else {
      // Change id of original almad-parade-1 and set display to none
      const paradeE = document.getElementById("almad-parade-1");
      if (paradeE) {
        paradeE.id = "almad-parade-removed";
      }
      window.ALMA.ad?.clear(["#almad-parade-removed"]);
      const removedParadeE = document.getElementById("almad-parade-removed");
      if (removedParadeE) {
        removedParadeE.style.display = "none";
      }

      // Create (move) almad-parade-1 inside almad-wallpaper-1
      const newParade1 = document.createElement("div");
      newParade1.setAttribute("id", "almad-parade-1");
      const wallpaperE = document.getElementById("almad-wallpaper-1");
      if (wallpaperE) {
        wallpaperE.appendChild(newParade1);
      }

      const paradeWallpaperE = document.getElementById(
        "almad-parade-wallpaper"
      );
      if (paradeWallpaperE) {
        paradeWallpaperE.style.height = "400px";
      }
    }
  } catch (e) {
    logger.logError("programmaticWallpaper", e);
  }
}

function closeILInterstitial(): void {
  const interstitialContainerE = window.document.getElementById(
    "interstitialContainer"
  );
  if (interstitialContainerE) {
    interstitialContainerE.style.display = "none";
  }
  const smokeScreen1E = window.document.getElementById("smokeScreen1");
  if (smokeScreen1E) {
    smokeScreen1E.style.display = "none";
  }
}

function blogitCenterParade(): void {
  const paradeE = window.document.getElementById("almad-parade-1");
  if (paradeE) {
    paradeE.style.textAlign = "center";
  }
}

const ilParade: Partial<IPlacement<ICustomVariables, SiteNativeTemplate>> = {
  customNeeds: {
    adAvailable(c: StackContext, adObj: IXandrAdObject): void {
      if (isBannerAdObject(adObj)) {
        paradeStyles(`${adObj.banner.height + 14}px`);
        detectProgrammaticWallpaper(adObj);
      }
    },
    adLoaded(): void {
      paradeStyles("auto");
    },
    adError(): void {
      paradeStyles("auto");
    },
    adRequestFailure(): void {
      paradeStyles("auto");
    },
    adNoBid(): void {
      paradeStyles("auto");
    },
  },
};

const outstreamStyles: Partial<
  IPlacement<ICustomVariables, SiteNativeTemplate>
> = {
  customNeeds: {
    adLoaded: (c: StackContext, adObj: IXandrAdObject): void => {
      outstream(adObj);
    },
  },
};

// eslint-disable-next-line import/prefer-default-export
export {
  changeParadeId,
  detectProgrammaticWallpaper,
  programmaticWallpaper,
  closeILInterstitial,
  blogitCenterParade,
  ilParade,
  outstreamStyles,
};
